export default "__VITE_ASSET__c67dd116__"